import axios from "axios";
import { serverData, serviceUrls } from "./constant";
import { getProfileDetails } from "../services/authentication";
import {
  get,
  patch,
  put,
  post,
  del,
  createQueryParams,
} from "./axiosComponent";

//Region Management
export const getRegionsList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/regions/list",
    params: createQueryParams(data),
  });
};

export const addRegion = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/regions", data: data });
};

export const updateRegionStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/organization/regions",
    params: createQueryParams(data),
  });
};
export const getRegionDetails = async (regionId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/regions",
    params: createQueryParams({ entityId: regionId }),
  });
};
export const updateRegion = async (data) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/organization/regions",
    data,
  });
};

export const deleteRegion = async (regionId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/regions",
    params: createQueryParams({ entityId: regionId }),
  });
};

//Site Management
export const getSitesList = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/sites/list",
    params: createQueryParams(data),
  });
};

export const addSite = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/sites", data: data });
};

export const updateStiteStatus = async (data) => {
  return await patch({
    url: serviceUrls.ADMIN_SERVICE + "/organization/sites",
    params: createQueryParams(data),
  });
};
export const updateSite = async (data) => {
  return await put({
    url: serviceUrls.ADMIN_SERVICE + "/organization/sites",
    data: data,
  });
};
export const getSiteDetails = async (siteId) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/sites",
    params: createQueryParams({ entityId: siteId }),
  });
};

export const getSiteFromAccessAPI = async ({
  regionId = null,
  pageNum = 1,
  organizationLevel = null,
  entityId = null,
} = {}) => {
  try {
    var organizationId = JSON.parse(localStorage.getItem("profileDetails"))
      ._ORGANIZATION_._ID;
    const params = {
      organizationId,
      pageNum,

      ...(regionId && { regionId }),
      ...(organizationLevel && { organizationLevel }),
      ...(entityId && { entityId }),
    };

    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    const res = await axios.get(
      `${serviceUrls.ADMIN_SERVICE}/v1/organization/access/list?${queryString}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.status === 200) {
      return { status: "success", data: res.data.response.entityList };
    } else {
      console.log(res, "get site from access api");
      return { status: "fail", message: "Server Error", data: [] };
    }
  } catch (error) {
    console.log(error, "get site from access api");
    return {
      status: "fail",
      message: error.message,
      data: [],
    };
  }
};

export const deleteSite = async (entityId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/sites",
    params: createQueryParams({ entityId }),
  });
};
